module.exports = __webpack_public_path__ + "img/icon_selected_no.18dabad5.svg";